import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { toast } from "react-toastify";
import { GET_STATES_BY_COUNTRY, TOAST_CONFIG } from "../../constants";
import { countryList } from "../../constants/constants";
import { handleAllowWholeNumberAsInput } from "../../utils/HelperFunctions";
import { get } from "../../utils/request";
import InputFieldWithLabel from "../molecules/forms/InputFieldWithLabel";
import SelectElement from "../molecules/forms/SelectElement";

function BrandAddressForm() {
  const {
    register,
    formState: { errors },
    watch,
  } = useFormContext();

  const [availableStateOptions, setAvailableStatesOptions] = useState();
  const [stateOptionsLoading, setStateOptionsLoading] = useState(false);

  async function getAndSetStatesForCountry(country: string) {
    try {
      setStateOptionsLoading(true);
      const states = await get(GET_STATES_BY_COUNTRY, {
        queryParams: {
          country,
        },
      });
      if (!states) {
        toast.error("Failed to get state for country", TOAST_CONFIG);
        return;
      }
      setAvailableStatesOptions(states);
    } catch (err) {
      console.log("Failed to load states for country");
      console.error(err);
    } finally {
      setStateOptionsLoading(false);
    }
  }

  const selectedCountry = watch("country");

  // Fetch states for a given country.
  useEffect(() => {
    if (selectedCountry) {
      getAndSetStatesForCountry(selectedCountry);
    }
  }, [selectedCountry]);

  return (
    <div className="mt-4 grid grid-cols-10 gap-x-4  gap-y-2 md:gap-x-12">
      <div className="col-span-10  md:col-span-5">
        <SelectElement
          label="Country*"
          id="country"
          register={register}
          additionalClasses=""
          placeHolder="Please Select Country"
          selectedValue={watch("country")}
          // @ts-ignore
          errorMessage={errors.country?.message}
          options={countryList}
          isCountrySelector
        />
      </div>
      <div className=" col-span-10 md:col-span-5">
        <SelectElement
          label="State*"
          id="state"
          register={register}
          placeHolder="Please Select State"
          selectedValue={watch("state")}
          // @ts-ignore
          errorMessage={errors.state?.message}
          options={availableStateOptions || []}
          optionsLoading={stateOptionsLoading}
        />
      </div>
      <div className="col-span-10 md:col-span-5">
        <InputFieldWithLabel
          label="City*"
          id="city"
          register={register}
          placeHolder="Enter the name of City"
          defaultValue=""
          // @ts-ignore
          errorMessage={errors.city?.message}
        />
      </div>
      <div className="col-span-10 md:col-span-5">
        <InputFieldWithLabel
          label="Zip Code*"
          id="zipcode"
          register={register}
          placeHolder="Enter the Zip or Postal code"
          defaultValue=""
          handleOnKeyDown={(e) => handleAllowWholeNumberAsInput(e, true)}
          // @ts-ignore
          errorMessage={errors.zipcode?.message}
        />
      </div>
    </div>
  );
}
export default BrandAddressForm;
